import { xySetYValue, zonesNormalize } from 'ml-spectra-processing';
export const id = 'exclusionZones';
export const name = 'Exclusion zones';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: false,
};
export function apply(spectrum, zones = []) {
    if (!isApplicable(spectrum)) {
        throw new Error('Exclusion Zones filter not applicable on this data');
    }
    const { x, re, im } = spectrum.data;
    spectrum.data.re = Float64Array.from(xySetYValue({ x, y: re }, { zones }).y);
    spectrum.data.im = im
        ? Float64Array.from(xySetYValue({ x, y: re }, { zones }).y)
        : im;
}
export function isApplicable(spectrum) {
    if (spectrum.info.isFt)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: zonesNormalize(previousValue.concat(newValue)),
    };
}
//# sourceMappingURL=exclusionZones.js.map